/**
 * Available hooks
 *
 * component.initialized(component)
 * elementInitialized(el, component)
 * element.removed(el, component)
 * message.sent(component, message)
 * message.failed(component)
 * message.received(component, response)
 * message.received(component, mutableHtmlContainer)
 * beforeElementUpdate(from, to, component)
 * element.updated(node, component)
 * message.processed(component)
 * interceptWireModelSetValue(el, value)
 * interceptWireModelAttachListener(el, directive, component, debounceIf)
 * directive(el, directive, component)
 *
 */

export default function() {
    window.Livewire.directive('overlay', (el, directive, component) => {
        component.__overlay_directive = true;
        component.__overlay = false;
        el.addEventListener(directive.modifiers[0], function(event) {
            event.preventDefault();
            component.__overlay = true;
            window.Livewire.dispatchTo('messenger', 'loading', true);
            component.call(directive.method, ...directive.params);
        });
    });
    window.Livewire.hook('message.failed', (component) => {
        if (!component.__overlay_directive) return;
        if (component.__overlay) {
            component.__overlay = false;
            window.Livewire.dispatchTo('messenger', 'loading', false);
        }
    });
    window.Livewire.hook('message.received', (component) => {
        if (!component.__overlay_directive) return;
        if (component.__overlay) {
            component.__overlay = false;
            window.Livewire.dispatchTo('messenger', 'loading', false);
        }
    });
}
